import { useCallback, useRef } from 'react';

import { useMediaQuery } from '@website/hooks/useMediaQuery';

export function useActivityCardRefs() {
  // Refs for the activity cards and container
  const listContainerRef = useRef<HTMLDivElement | null>(null);
  const activityCardRefs = useRef<Map<string, HTMLDivElement>>(new Map());

  // Check if screen is mobile (max-width: 767px)
  const isMobile = useMediaQuery('(max-width: 767px)');

  // Function to register refs for activity cards
  const registerCardRef = useCallback((id: string, element: HTMLDivElement | null) => {
    if (element) {
      activityCardRefs.current.set(id, element);
    } else {
      activityCardRefs.current.delete(id);
    }
  }, []);

  // Scroll a card into view (helper function)
  const scrollCardIntoView = useCallback(
    (activityId: string) => {
      if (isMobile) return; // Don't scroll on mobile

      setTimeout(() => {
        const cardElement = activityCardRefs.current.get(activityId);
        if (cardElement && listContainerRef.current) {
          console.log('Attempting to scroll card into view:', activityId);

          const containerRect = listContainerRef.current.getBoundingClientRect();
          const cardRect = cardElement.getBoundingClientRect();

          const isFullyVisible = cardRect.top >= containerRect.top && cardRect.bottom <= containerRect.bottom;

          if (!isFullyVisible) {
            cardElement.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }
        } else {
          console.log('Card element or container not found for scrolling:', activityId);
        }
      }, 0);
    },
    [isMobile]
  );

  return {
    listContainerRef,
    activityCardRefs,
    registerCardRef,
    scrollCardIntoView,
    isMobile
  };
}
